import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { EPreferredCommunicationType } from '../types';

export const CHANGE_PREFERRED_COMMUNICATION_TYPE = 'OFFER :: CHANGE_PREFERRED_COMMUNICATION_TYPE';

export type TChangePreferredCommunicationTypeAction = IReduxAction<
  typeof CHANGE_PREFERRED_COMMUNICATION_TYPE,
  EPreferredCommunicationType
>;

export const changePreferredCommunicationType = actionGenerator<
  typeof CHANGE_PREFERRED_COMMUNICATION_TYPE,
  EPreferredCommunicationType
>(CHANGE_PREFERRED_COMMUNICATION_TYPE);
